"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSpan = void 0;
const dateParse_1 = require("./methods/dateParse");
const padNumber_1 = require("./methods/padNumber");
/**
 * klasa reprezentująca różnicę czasu
 */
class TimeSpan {
    static diff(lateDate, earlyDate) {
        try {
            const dt1 = typeof lateDate === 'string' ? (0, dateParse_1.dateParse)(lateDate) : lateDate;
            const dt2 = typeof earlyDate === 'string' ? (0, dateParse_1.dateParse)(earlyDate) : earlyDate;
            const offset = dt1.getTimezoneOffset() - dt2.getTimezoneOffset(); // zeby pomiedzy datami z czasu zimowego i letniego było dokładnie 24 h
            // return new TimeSpan(dt1.getTime() - dt2.getTime(), dt1, dt2);
            return new TimeSpan(dt1.getTime() - dt2.getTime() - offset * 60 * 1000, dt1, dt2);
        }
        catch (err) {
            if (process.env.NODE_ENV !== 'production') {
                console.error(`[DEBUG] invalid TimeSpan("${lateDate}","${earlyDate}")`, err);
                // eslint-disable-next-line no-debugger
                debugger;
            }
            return new TimeSpan(0);
        }
    }
    constructor(ms, lateDate, earlyDate) {
        this.ms = ms;
        this.lateDate = lateDate;
        this.earlyDate = earlyDate;
    }
    /**
     * całkowita liczba milisekund
     */
    get totalMiliseconds() {
        return this.ms;
    }
    /**
     * ilośc milisekund po odjęciu sekund, minut, godzin i dni
     */
    get miliseconds() {
        return this.ms % 1000;
    }
    /**
     * całkowita liczba sekund = liczba milisekund /1000
     */
    get totalSeconds() {
        return this.ms / 1000;
    }
    /**
     * liczba sekund po odjęciu minut, godzin i dni
     */
    get seconds() {
        // return this.ms % (1000 * 60);
        return Math.trunc((this.totalMinutes % 1) * 60);
    }
    /**
     * całkowita liczba minut
     */
    get totalMinutes() {
        return this.ms / 60000 /* 1000 * 60 */;
    }
    /**
     * liczba minut po odjęciu godzin i dni
     */
    get minutes() {
        return Math.trunc((this.totalHours % 1) * 60);
    }
    /**
     * całkowita liczba godzin
     */
    get totalHours() {
        return this.ms / 3600000 /* 1000 * 60 * 60 */;
    }
    /**
     * liczba godzn po odjęciu liczby dni
     */
    get hours() {
        return Math.trunc((this.totalDays % 1) * 24);
    }
    /**
     * całkowita liczba dni
     */
    get totalDays() {
        return this.ms / 86400000 /*1000 * 60 * 60 * 24*/;
    }
    /**
     * liczba dni, wartośc całkowita
     */
    get days() {
        return Math.trunc(this.totalDays);
    }
    /**
     * liczba miesięcy, wartośc całkowita
     */
    get months() {
        if (this.earlyDate && this.lateDate) {
            let res = (this.lateDate.getFullYear() - this.earlyDate.getFullYear()) * 12;
            res += this.lateDate.getMonth();
            res -= this.earlyDate.getMonth();
            if (res > 0) {
                if (this.lateDate.getDate() < this.earlyDate.getDate()) {
                    res--;
                }
            }
            else if (res < 0) {
                if (this.lateDate.getDate() > this.earlyDate.getDate()) {
                    res++;
                }
            }
            return res;
        }
        else {
            return Math.trunc(this.days / 30);
        }
    }
    /**
     * liczba lat, wartość całkowita
     */
    get years() {
        return Math.trunc(this.months / 12);
    }
    /**
     * róznica w postaci HH:mm:ss
     */
    toString() {
        return ((0, padNumber_1.padNumber)(Math.trunc(this.totalHours), 2) + ':' + (0, padNumber_1.padNumber)(this.minutes, 2) + ':' + (0, padNumber_1.padNumber)(this.seconds, 2));
    }
}
exports.TimeSpan = TimeSpan;
//# sourceMappingURL=TimeSpan.js.map